class ErrorHandler {
  reportError = (error) => {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export default new ErrorHandler();
